import { REVISE_ROUTINE } from "../constants/url";
import { catchErrors } from "../utils/catchErrors";
import { getApiCall, genericApiCall } from "../utils/servicesBaseUtil";
import { message } from "antd";

const getReviseRoutineApi = ({
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = `${REVISE_ROUTINE}`;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

const saveReviseRoutineApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = REVISE_ROUTINE;
    genericApiCall({
      url: url,
      method: "POST",
      data: JSON.stringify(data),
      ContentType: "application/json",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export { getReviseRoutineApi, saveReviseRoutineApi };
